import {
  BooleanField,
  DataTable,
  List,
  ListActions,
  NeutralBadge,
  NumberField,
  SearchInput,
} from "../../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const PayrollComponentList = () => (
  <List
    title="Payroll Components"
    filters={filters}
    actions={<ListActions label="Add Component" />}
    sort={{ field: "sort_order", order: "ASC" }}
  >
    <div className="employees-table-container">
      <DataTable rowClick="edit" className="employees-table">
        <DataTable.Col source="code" label="Code" className="employee-code" />
        <DataTable.Col source="name" label="Name" className="employee-name" />
        <DataTable.Col label="Type">
          <NeutralBadge source="type" />
        </DataTable.Col>
        <DataTable.Col label="Calculation">
          <NeutralBadge source="calculation" />
        </DataTable.Col>
        <DataTable.Col source="value" label="Value">
          <NumberField source="value" />
        </DataTable.Col>
        <DataTable.Col source="taxable" label="Taxable">
          <BooleanField source="taxable" />
        </DataTable.Col>
      </DataTable>
    </div>
  </List>
);

